import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface RespondentColumnDTO {
  column: string;
}

export class RespondentColumn {
  readonly isRespondentColumnRespondentColumn: boolean = true;

  readonly column: string;

  static readonly constraints = {
    "column": {
      "maxSize": 300,
      
      
      
      
    }
  }

  constructor(
  column: string
  ) {
    RespondentColumn.validateColumn(column);
    this.column = column;
  }

  static fromDTO(dto: RespondentColumnDTO): RespondentColumn {
    const column = getString(dto, "column", InvalidRespondentColumnColumnError);
    return new RespondentColumn(
      column
    );
  }

  toDTO(): RespondentColumnDTO {
    const dto: RespondentColumnDTO = {
        column: this.column
    };
    return dto;
  }
  private static validateColumn = (column: string): void => {
    if(column.length > 300) {
      throw new InvalidRespondentColumnColumnMaxSizeError(
        300,
        `Attribute column is too long. Size is ${column.length}. Max size is 300.`
      );
    }
      if(column.trim().length === 0) {
        throw new InvalidRespondentColumnColumnNonEmptyError(
          `Attribute column cannot be an empty string.`
        );
      }
  }
  
}

RespondentColumn.prototype.toString = function toString(): string {
  return `RespondentColumn(column='${this.column}')`;
};

export class InvalidRespondentColumnError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumnError";
  }
}
export class InvalidRespondentColumnColumnError extends InvalidRespondentColumnError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumnColumnError";
  }
}

export class InvalidRespondentColumnColumnMaxSizeError extends InvalidRespondentColumnColumnError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumnColumnMaxSizeError";
  }
}

export class InvalidRespondentColumnColumnNonEmptyError extends InvalidRespondentColumnColumnError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumnColumnNonEmptyError";
  }
}
